import { FC } from 'react';
import './styles.scss';

interface FormTitleProps {
	title: string;
	subTitle?: string;
}

const FormTitle: FC<FormTitleProps> = (props) => {
	const { title, subTitle } = props;

	return (
		<div className="formTitle">
			<div className="formTitle__title" dangerouslySetInnerHTML={{ __html: title }} />
			<p className="formTitle__text">{subTitle}</p>
		</div>
	);
};

export default FormTitle;
